import React from "react";
import useObjectInput from "../../../hooks/useObjectInput";
import ErrorDetail from "./ErrorDetail";
import ManageError from "./ManageError";
import "./index.css";

// Renders the error section, and displays the errors
const GOIErrors = () => {
  const {
    handleHighlightData,
    findErrorObjectById,
    emptyHighlightData,
    showErrors,
    setShowFieldsToTrue,
    highlightData,
    highlight,
    setHighlight,
    changeVisibleHeaderValues,
    setId,
    setTreeViewIds,
    treeViewIds,
    reqResponse,
  } = useObjectInput();

  const convertTime = (milliseconds) => {
    if (milliseconds > 3600000) {
      return (milliseconds / 3600000).toFixed(0) + " h";
    } else if (milliseconds > 60000) {
      return (milliseconds / 60000).toFixed(0) + " min";
    } else if (milliseconds > 1000) {
      return (milliseconds / 1000).toFixed(0) + " sec";
    } else {
      return milliseconds + " milliseconds";
    }
  };

  const continueExecution = (e, object) => {
    const dataToToggleFrom = highlightData.objectId ? highlightData : object;
    changeVisibleHeaderValues(dataToToggleFrom.objectId, true);
    setId(e.target.className);
    const isLastNode = reqResponse["idValue"][e.target.className];
    // call changeView here to switch view
    setTreeViewIds({
      ...treeViewIds,
      [e.target.className]: !isLastNode.hasOwnProperty("savedValue"),
    });
    setShowFieldsToTrue(dataToToggleFrom.objectId);
    dataToToggleFrom.dependenciesId.map((depId) => setShowFieldsToTrue(depId));
    const data = findErrorObjectById(e.target.id);
    const myDiv = document.getElementById(data.errorAtObjectId);

    if (myDiv) {
      const offset = myDiv.getBoundingClientRect().top + 210;
      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    }
  };

  const handleRuleBrokenObject = (e) => {
    if (!highlightData.objectId) {
      handleShowHighlight(e, continueExecution);
    } else {
      continueExecution(e);
    }
  };

  const handleStopHighlight = () => {
    setHighlight(false);
    emptyHighlightData();
  };

  const handleShowHighlight = (e, callback) => {
    setHighlight(true);
    handleHighlightData(e, callback);
  };

  return (
    <div>
      {showErrors && (
        <ErrorDetail
          highlight={highlight}
          convertTime={convertTime}
          handleStopHighlight={handleStopHighlight}
          handleShowHighlight={handleShowHighlight}
          handleRuleBrokenObject={handleRuleBrokenObject}
        />
      )}
      {/* displays error toast and allows user to perform different actions like show / hide errors or remove error highlight */}
      <ManageError handleStopHighlight={handleStopHighlight} />
    </div>
  );
};

export default GOIErrors;
